import {
    Button,
    Card, CardBody,
    CardHeader,
    Container,
    FormGroup, Input, Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row, Table
} from "reactstrap";
import { FaEdit, FaPlus } from "react-icons/fa";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import EeiServices from "../../service/eei";
import DataTable from "react-data-table-component";
import { tableCustomStyle } from "utils";

const EventCategory = () => {
    // region data
    const [modal, setModal] = useState({
        isOpen: false,
        title: "",
        isEdit: false
    })

    const [eventCategory, setEventCategory] = useState({
        id: 0,
        name: '',
        isActive: true
    })

    const [listEventCategory, setListEventCategory] = useState({
        data: [],
        statusCode: 0
    })
    // endregion data

    // region method
    async function getEventCategory() {
        try {
            const eeiServices = new EeiServices();

            await Swal.fire({
                title: "Loading",
                async didOpen() {
                    Swal.showLoading();
                    setListEventCategory(await eeiServices.getEventCategory());
                    Swal.close();
                }
            });
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Get Event Category',
                text: e.message,
            });
        }
    }

    function resetEventCategory() {
        setEventCategory({
            id: 0,
            name: '',
            isActive: true
        })
    }

    async function handleSubmit() {
        try {
            const eeiService = new EeiServices();
            await eeiService.postEventCategory(eventCategory);

            await Swal.fire({
                icon: "success",
                title: "Success Add Event Category"
            });

            resetEventCategory();
            toggleModal()
            await getEventCategory();
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Add Event Category',
                text: e.message,
            });
        }
    }

    function toggleModal() {
        setModal({
            ...modal,
            isOpen: !modal.isOpen
        })
    }

    async function handleEdit() {
        try {
            const eeiService = new EeiServices();

            await Swal.fire({
                title: "Loading",
                async didOpen() {
                    Swal.showLoading();
                    await eeiService.editEventCategory(eventCategory);
                    Swal.close();
                }
            });

            await Swal.fire({
                icon: "success",
                title: "Success Edit Event Category"
            });

            resetEventCategory();
            toggleModal();
            await getEventCategory();
        }
        catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Failed to Edit Event Category',
                text: e.message,
            });
        }
    }
    // endregion method

    useEffect(() => {
        getEventCategory()
            .then(() => console.log(Math.random()));
    }, []);

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Status',
            selector: row => row.is_active ? "Active" : "Inactive",
        },
        {
            name: 'Actions',
            selector: row => row.id,
            cell: row => (
                <>
                    <Button
                        color={"info"}
                        size={"sm"}
                        className={"mr-2"}
                        onClick={() => {
                            setModal({
                                title: "Edit Event Category",
                                isOpen: !modal.isOpen,
                                isEdit: true
                            })

                            setEventCategory({
                                id: row.id,
                                name: row.name,
                                isActive: row.is_active
                            })
                        }}>
                        <FaEdit />
                    </Button>
                </>
            )
        }
    ];

    return (
        <>
            <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
                <Container className="mt-2" fluid>
                    <Row>
                        <div className="col">
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent border-0 d-flex justify-content-between align-items-center">
                                    <h3 className="text-white mb-0">
                                        Event Category
                                    </h3>
                                    <Button color="primary" onClick={() => {
                                        setModal({
                                            isOpen: !modal.isOpen,
                                            title: "Add Event Category",
                                            isEdit: false
                                        })
                                    }}>
                                        <FaPlus className="mr-2" />
                                        Add
                                    </Button>
                                </CardHeader>

                                <CardBody>
                                <DataTable
                                    customStyles={tableCustomStyle}
                                    columns={columns}
                                    data={listEventCategory.data}
                                />
                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                </Container>

                <Modal
                    className="modal-dialog-centered"
                    isOpen={modal.isOpen}
                    size={"m"}
                    onClosed={resetEventCategory}
                    toggle={toggleModal}
                >
                    <ModalHeader toggle={toggleModal}>
                        {modal.title}
                    </ModalHeader>
                    <form onSubmit={(ev) => {
                        modal.isEdit ? handleEdit() : handleSubmit()
                    }} >
                        <ModalBody>
                            <FormGroup>
                                <Label for={"event-category-name"}>
                                    Name
                                </Label>

                                <Input
                                    id={"event-category-name"}
                                    type={"text"}
                                    value={eventCategory.name}
                                    onChange={event => {
                                        setEventCategory({
                                            ...eventCategory,
                                            name: event.target.value
                                        })
                                    }} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for={"event-category-is-active"}>
                                    Is Active
                                </Label>

                                <Input
                                    id={"event-category-is-active"}
                                    type={"select"}
                                    defaultValue={eventCategory.isActive}
                                    onChange={event => {
                                        setEventCategory({
                                            ...eventCategory,
                                            isActive: event.target.value === "true"
                                        })
                                    }}>
                                    <option value={"true"}>True</option>
                                    <option value={"false"}>False</option>
                                </Input>
                            </FormGroup>
                        </ModalBody>

                        <ModalFooter>
                            <Button color="secondary" onClick={toggleModal}>
                                Cancel
                            </Button>

                            <Button color="primary" type="submit" >
                                {modal.isEdit ? "Update" : "Post"} Event
                            </Button>
                        </ModalFooter>
                    </form>
                </Modal>
            </div>
        </>
    )
}

export default EventCategory;
